<template>
  <div>
    <RegistrationForm
      v-if="step === 'form' && formData"
      :form-data="formData"
      :is-new="false"
      @submit="handleFormSubmit"
    />
    <RegistrationConfirm
      v-else-if="step === 'confirm'"
      :form-data="formData"
      :is-new="false"
      @goBack="step = 'form'"
      @submit="handleConfirmSubmit"
    />
    <RegistrationCompleted
      v-else-if="step === 'completed'"
      :is-subscribed="false"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RegistrationForm from './_Form'
import RegistrationConfirm from '../shared/Confirm'
import RegistrationCompleted from '../shared/Completed'

export default {
  name: 'EdiRequestUnsubscribedEdit',
  components: { RegistrationForm, RegistrationConfirm, RegistrationCompleted },
  props: {
    ediRequestId: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      step: 'form',
      formData: null
    }
  },
  watch: {
    step() {
      this.$nextTick(() => {
        this.scrollToTop()
      })
    }
  },
  created() {
    this.fetchEditData()
  },
  methods: {
    ...mapActions('EdiRequestUnsubscribed', {
      fetchEdit: 'edit',
      updateUnsubscribed: 'update',
    }),
    fetchEditData() {
      const id = this.ediRequestId
      this.fetchEdit({ id }).then(content => {
        // APIから取得したデータをformDataに設定
        this.formData = {
          id: content.id,
          corporation_code: content.corporation_code,
          corporate_designation_type: content.corporate_designation_type,
          emission_name: content.emission_name,
          emission_name_kana: content.emission_name_kana,
          emission_location_name: content.emission_location_name,
          emission_location_name_kana: content.emission_location_name_kana,
          representative_last_name: content.representative_last_name,
          representative_first_name: content.representative_first_name,
          representative_last_name_kana: content.representative_last_name_kana,
          representative_first_name_kana: content.representative_first_name_kana,
          zip_code: content.zip_code,
          prefecture_code: content.prefecture_code,
          address_1: content.address_1,
          address_2: content.address_2,
          address_3: content.address_3,
          phone_number: content.phone_number,
          same_as_representative: content.same_as_representative,
          contact_last_name: content.contact_last_name,
          contact_first_name: content.contact_first_name,
          contact_last_name_kana: content.contact_last_name_kana,
          contact_first_name_kana: content.contact_first_name_kana,
          contact_phone_number: content.contact_phone_number,
          email: content.email,
          transport_name: content.transport_name,
          industry_code: content.industry_code,
          visibility_type: content.visibility_type,
          visibility_url: content.visibility_url,
        }
      }).catch(error => {
        console.error('データの取得に失敗しました', error)
      })
    },
    handleFormSubmit(formData) {
      this.formData = formData
      this.step = 'confirm'
    },
    handleConfirmSubmit() {
      const id = this.ediRequestId
      const formData = { ...this.formData }
      
      // visibility_url をエンコード
      if (formData.visibility_url) {
        formData.visibility_url = encodeURIComponent(formData.visibility_url)
      }
      
      const payload = {
        emission_request: formData
      }
      this.updateUnsubscribed({ id, data: payload }).then(() => {
        this.$router.push({ name: 'AdminEdiRequests' })
      }).catch(error => {
        console.error('更新に失敗しました', error)
      })
    },
    scrollToTop() {
      const targets = [
        document.scrollingElement,
        document.documentElement,
        document.body,
        document.querySelector('.v-main__wrap'),
        document.querySelector('.v-application--wrap')
      ]

      targets.forEach(target => {
        if (!target) return
        if (typeof target.scrollTo === 'function') {
          target.scrollTo(0, 0)
        }
        target.scrollTop = 0
      })
    }
  }
}
</script>
